import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTRelMcCpsFisc = () => {
  const result = useAccountRateFieldApi({
    field: 'T_REL.MC_CPSFISC',
  });
  return result;
};
